/* global $:false, data:false */

var generic = generic || {};
var site = site || {};

site.offerspick = site.offerspick || {};
site.template = site.template || {};
site.onLoadRpc = site.onLoadRpc || {};

site.offerspick = {
  offercode: '',
  template: 'offers_pick_item_v1',
  products: '',
  productData: [],
  selectedSku: 0,
  eventCount: 0,
  transData: {
    offers: '',
    samples: ''
  },
  init: function () {
    this.getData();
  },
  getData: function () {
    var self = this;

    self.offercode = $('.offerspick').data('offercode');
    // console.log('offercode: ' + self.offercode);
    // choicesPcatData ?
    // 'method': 'offers.query'
    site.onLoadRpc.requests.push({
      'method': 'offer',
      'params': [self.offercode],
      onSuccess: function (data) {
        var offer = data.result.value;
        var isActive = offer && (offer.timing === 'active');

        // show if active
        if (isActive) {
          self.products = offer.benefits[0].choices;
          $(document).trigger('offerData:loaded');
        }
      },
      onFailure: function (data) {}
    });
    // trans info
    site.onLoadRpc.requests.push({
      'method': 'trans.get',
      'params': [
        {
          'trans_fields': ['TRANS_ID', 'totals'],
          'payment_fields': [],
          'order_fields': ['items', 'samples', 'offerCodes']
        }
      ],
      onSuccess: function (data) {
        // console.log('trans.get');
        // console.log(data);
        try {
          self.transData.offers = data.result.value.offerCodes;
          self.transData.samples = data.result.value.order.samples;
        } catch (e) {}
        $(document).trigger('transData:loaded');
      },
      onFailure: function (data) {}
    });
  },
  getProducts: function () {
    var self = this;
    var params = {
      'query_key': 'catalog-mpp',
      'products': self.products
    };

    generic.jsonrpc.fetch({
      method: 'prodcat.querykey',
      params: [params],
      onSuccess: function (response) {
        // console.log(response.getValue());
        var sortProdCatDisplayOrder = response.getValue().products;

        sortProdCatDisplayOrder.sort(function (a, b) {
          return a.PROD_CAT_DISPLAY_ORDER - b.PROD_CAT_DISPLAY_ORDER;
        });
        self.productData = sortProdCatDisplayOrder;
        // console.log(self.productData);
        self.renderProducts();
      },
      onFailure: function (response) {}
    });
  },
  renderProducts: function () {
    var self = this;

    $.each(self.productData, function (index, product) {
      var data = {};
      var sku = product.skus[0];

      // console.log(sku);
      data.header = product.PROD_RGN_SUBHEADING;
      // data.button = 'add to bag'; // from cms
      data.sku_base_id = sku.SKU_BASE_ID; // sku.PRODUCT_CODE
      data.product_id = sku.PRODUCT_ID;
      // check inventory
      var inventory = sku.INVENTORY_STATUS;

      // check inventory
      data.stock = inventory == 2 || inventory == 3 || inventory == 5 || inventory == 7 ? 0 : 1;
      data.shades = [];
      var productCode = sku.PRODUCT_CODE;
      var shades = sku.SHADENAME.split(',');
      var hexes = sku.HEX_VALUE_STRING.split(',');

      // sku.IMAGE_M bb_sku_EF0Y02_290x315_0.jpg
      $.each(shades, function (index, shade) {
        data.shades.push({
          'image': '/media/export/cms/offers/offerspick/bb_smoosh_' + productCode + '_' + index + '.jpg',
          'shadename': shade,
          'hex': hexes[index]
        });
      });
      var $offer = site.template.get({
        name: self.template,
        data: data
      });

      $('.offerspick__offers', '.offerspick').append($offer);
    });
    // check inventory
    self.checkCart();
  },
  checkCart: function () {
    var self = this;

    // is item alredy in cart?
    $.each(self.transData.offers, function (index, offer) {
      if (offer === self.offercode) {
        $.each(self.transData.samples, function (index, sample) {
          // sample.sku.SKU_BASE_ID
          // console.log(sample['sku.SKU_BASE_ID']);
          var cartSku = sample['sku.SKU_BASE_ID'];
          var $selected = $('.js-add-offer[data-sku-base-id="' + cartSku + '"]', '.offerspick');

          if ($selected.length) {
            self.selectedSku = sample['sku.SKU_BASE_ID'];
          }
        });
      }
    });

    self.cartActions();
  },
  cartActions: function () {
    var self = this;
    // add to cart
    var $addBtns = $('.js-add-offer', '.offerspick');

    $addBtns.click(function (event) {
      var skuBaseId = $(this).data('sku-base-id');

      self.addOfferCart(skuBaseId);
    });
    // remove from cart
    var $removeBtns = $('.js-remove-offer', '.offerspick');

    $removeBtns.click(function (event) {
      var skuBaseId = $(this).data('sku-base-id');

      self.removeOfferCart(skuBaseId);
    });

    // already in cart
    if (self.selectedSku) {
      self.offerSelected();
    }
  },
  addOfferCart: function (skuBaseId) {
    var self = this;

    self.selectedSku = skuBaseId;
    var skuBaseId = skuBaseId.toString();
    // offer.apply
    var params = {
      'offer_code': self.offercode,
      'benefits': {
        'ChoiceOfSkus': {
          'choices': [skuBaseId]
        }
      }
    };

    generic.jsonrpc.fetch({
      method: 'offers.apply',
      params: [params],
      onSuccess: function (response) {
        // console.log('added to cart');
        // console.log(response.getValue());
        // console.log(response.getMessages());
        self.offerSelected();
        self.cartConfirm();
      },
      onFailure: function (response) {
        // display error
        console.log('error adding to cart');
      }
    });
  },
  removeOfferCart: function () {
    // offer.removeOfferByCode
    var self = this;
    var params = {
      'offer_code': self.offercode
    };

    generic.jsonrpc.fetch({
      method: 'offer.removeOfferByCode',
      params: [params],
      onSuccess: function (response) {
        // console.log('removed');
        // console.log(response.getValue());
        // console.log(response.getMessages());
        self.offerRemoved();
      },
      onFailure: function (response) {
        // display error
        console.log('error adding to cart');
      }
    });
  },
  offerSelected: function () {
    var self = this;
    // $('.offerspick__offer','.offerspick').addClass('hidden');
    var $selected = $('.js-add-offer[data-sku-base-id="' + self.selectedSku + '"]', '.offerspick').closest('.offerspick__offer');

    $('.offerspick__offer', '.offerspick').not($selected).addClass('hidden');
    $selected.removeClass('hidden').addClass('is_selected');
    var $container = $('.offerspick').closest('.product_collection_hero__content-item');

    $('.offerspick').addClass('offerspick--selected');
    if ($container.length) {
      $('html, body').animate({
        scrollTop: $container.offset().top - 100
      }, 100);
    }
  },
  offerRemoved: function () {
    $('.offerspick__offer', '.offerspick').removeClass('hidden is_selected');
    $('.offerspick').removeClass('offerspick--selected');
  },
  cartConfirm: function () {
    // copied from cart_confirm.js
    // js/shared/cart_confirm.js
    generic.jsonrpc.fetch({
      'method': 'trans.get',
      'params': [
        {
          'trans_fields': ['TRANS_ID', 'totals'],
          'payment_fields': [],
          'order_fields': ['items', 'samples', 'offerCodes']
        }
      ],
      'onSuccess': function (d) {
        var cartResponse = d.getValue();

        if ((typeof cartResponse === 'undefined') || !cartResponse) {
          return;
        }
        var args = {
          trans: cartResponse,
          items: cartResponse.order.items
        };

        site.cartConfirm.launch(args);
      },
      onError: function () {}
    });
  }
};

$(document).on('offerData:loaded transData:loaded', function (event) {
  if (event.type === 'offerData:loaded') {
    // console.log('offerData:loaded');
    site.offerspick.eventCount++;
  } else if (event.type === 'transData:loaded') {
    // console.log('transData:loaded');
    site.offerspick.eventCount++;
  }
  if (site.offerspick.eventCount === 2) {
    // console.log('all data loaded');
    site.offerspick.getProducts();
  }
});

$(document).on('foundation_finder_grid', function (e, grid) {
  // not always ready on load
  var $grid = $(grid);
  var $lastImage = $('.product-thumb__image', $grid).last();

  $($lastImage).load(function () {
    Drupal.behaviors.productGrid.equalHeights($grid.parent());
  });
});

(function ($) {
  Drupal.behaviors.offersPick = {
    attach: function (context) {
      site.offerspick.init();
    }
  };
})(jQuery);
